<template>
  <b-container>
    <b-card
      v-if="renderPage"
      id="tour-card"
    >
      <validation-observer
        ref="simpleRules"
        #default="{ invalid }"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Observações"
                label-for="v-obs"
              >
                <validation-provider
                  #default="{ errors }"
                  name="observations"
                  rules="required"
                >
                  <b-form-textarea
                    id="textarea-default"
                    v-model="description"
                    rows="3"
                    :state="errors.length > 0 ? false : null"
                    no-resize
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="info"
                  class="btn-send"
                  :disabled="invalid"
                  @click.prevent="validationForm()"
                >
                  Enviar
                </b-button>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Entre em contato tambem pelos canais:">
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?1=pt_BR&phone=551155552144&text=Olá%2C%20Quero%20falar%20com%20um%20especialista"
                ><b-img
                  fluid
                  src="@/assets/images/icons/whats.png"
                  class="mr-2"
                /></a>
                <span class="phone">(11) 5555 - 2144 </span> <span> Segunda a sexta das 08:00 até 17:00 hrs e sabado e domingo das 8:00 até 20:00 hrs.</span>
              </b-form-group>
              <b-form-group>
                <b-img
                  fluid
                  src="@/assets/images/icons/call.png"
                  class="mr-2"
                />
                <span class="phone">(11) 5555 - 2144 </span> <span> Segunda a sexta das 08:00 até 17:00 hrs e sabado e domingo das 8:00 até 20:00 hrs.</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-container>
</template>
<script>
import {
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BCard,
  BForm,
  BButton,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

import sendMail from '@/service/contact-us/contact-us'

import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BCard,
    BForm,
    BButton,
    BImg,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      renderPage: true,
      customerEmail: null,
      description: null,
      required,
      email,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.sendMail()
        }
      })
    },
    async sendMail() {
      callLoading(true, true)
      const data = {
        text: this.description,
      }
      const response = await sendMail(data)
      const { status } = response

      if (status === 200) {
        this.$swal({
          text: 'Email enviado com sucesso',
          icon: 'success',
          timer: '1750',
          showConfirmButton: false,
          buttonsStyling: false,
        })
      } else {
        this.$swal({
          text: 'Não foi possível enviar o email',
          icon: 'error',
          timer: '1750',
          showConfirmButton: false,
          buttonsStyling: false,
        })
      }

      callLoading(false)
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@core/scss/vue/pages/contactUs-style.scss";
  .phone {
    font-weight: 500;
  }
</style>
